import React, {Component} from 'react';
import classNames from "classnames";
import * as Formatter from '../../utils/formatters';
import * as Request from '../../service/data-info-chart/requestsUtil';
import * as cbu from "../../utils/checkBusinessUnit";
import {ACCOUNTS_SURFACE_DIFFERENCE} from "../../utils/constants";

var Loader = require('react-loader');

export default class SurfaceDifference extends Component {
  constructor(props) {
    super(props);
    this.state={data:[], loaded:false}
  }

  componentDidMount(){
    Request.getFetch(ACCOUNTS_SURFACE_DIFFERENCE + cbu.checkBusinessUnit(this.props.bu))
      .then((json)=>{
        this.setState({data:json, loaded:true});
      });
  }

  render() {

    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.striped,
      'table-bordered': this.props.bordered,
      'table-hover': this.props.hover,
      'table-condensed': this.props.condensed
    });

    let rows = this.state.data.map((value)=>{
      return(<tr><th>{Formatter.setFirstCapital(value.month)}</th><td className={'text-center'}>{Formatter.formatNumber(value.inValidation)}</td><td className={'text-center'}>{Formatter.formatNumber(value.aproved)}</td></tr>);
    });

    return (
      <Loader loaded={this.state.loaded}>
      <table className={tableClass}>
        <thead style={{color: '#FFF', backgroundColor: '#78909C'}}>
        <tr>
          <th style={{width:'33%', verticalAlign:'middle'}} className={'text-center'}>Mes</th>
          <th style={{width:'33%', verticalAlign:'middle'}} className={'text-center'}>Cuéntas en validación</th>
          <th style={{width:'33%', verticalAlign:'middle'}} className={'text-center'}>Cuentas aprovadas con nuevo valor catastral</th>
        </tr>
        </thead>
        <tbody>
        {rows}
        </tbody>
      </table>
      </Loader>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/tables/SurfaceDifference.js